import { DealType, EDealType } from 'shared/types/filters';

export const DEAL_TYPES: DealType[] = [
  { label: 'Купить', value: EDealType.Sale },
  { label: 'Снять', value: EDealType.Rent },
];
